<!-- <p>
  verify-otp-modal works!
</p> -->
<ng-container *ngIf="showModal">

	<div class="modal fade show" [id]="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" style="display: block;">
		<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
			<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLongTitle">Add Employer</h5>
				<button type="button" class="close" (click)="cancel()" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">×</span>
				</button>
			</div>
			<ng-container [formGroup]="verifyOtpForm">
				<div class="modal-body">
					<div class="m-form__section m-form__section--first">
						<div class="form-group m-form__group">
							<label for="example_input_full_name">{{label.mobileInputLabel}}:</label>
							<input type="number" formControlName="phone" class="form-control m-input" [placeholder]="placeholder.mobilePlaceholder">
							<app-form-control-messages [control]="verifyOtpForm.get('phone')"
							[name]="'Mobile One Time Password'"></app-form-control-messages>
						</div>
						<div class="form-group m-form__group">
							<label>{{label.emailInputLabel}}:</label>
							<input type="number" formControlName="email" class="form-control m-input" [placeholder]="placeholder.emailPlaceholder">
							<app-form-control-messages [control]="verifyOtpForm.get('email')"
							[name]="'Email One Time Password'"></app-form-control-messages>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" (click)="cancel()" data-dismiss="modal">Close</button>
					<button type="button" class="btn btn-primary" [disabled]="verifyOtpForm.invalid" (click)="verifyOtp()">{{submitButtonName}}</button>
				</div>
			</ng-container>
			</div>
		</div>
	</div>
</ng-container>
